import { render, staticRenderFns } from "./GetDate.vue?vue&type=template&id=04afd3de"
import script from "./GetDate.vue?vue&type=script&lang=js"
export * from "./GetDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports